<template>
    <div v-if="employeePayrollData" class="cpfl-wrap">
        <!-- Employee selector bar -->
        <div class="cpfl-selector-bar">
            <div class="cpfl-selector-left">
                <i class="fas fa-user-check cpfl-selector-icon"></i>
                <span class="cpfl-selector-label">Select Employees</span>
                <span class="cpfl-selector-hint">(Deactivated employees are excluded)</span>
            </div>
            <button class="cpfl-select-all-btn" @click="selectedEmployeeIds = employeePayrollData.map((item) => item.id)">
                <i class="fas fa-check-double"></i> Select All
            </button>
        </div>
        <div class="cpfl-dropdown-wrap">
            <SelectDropdown
                :id="`employee_creation`"
                :options="employeePayrollData.map((item) => ({ id: item.id, title: `${item.firstName} ${item.lastName}` }))"
                :multiple="true"
                :value="selectedEmployeeIds"
                @change="selectedEmployeeIds = $event"
            />
        </div>

        <!-- Count badge -->
        <div class="cpfl-count" v-if="filteredEmployeePayrollData.length">
            <span class="cpfl-count-badge">{{ filteredEmployeePayrollData.length }}</span> employee{{ filteredEmployeePayrollData.length !== 1 ? 's' : '' }} selected
        </div>

        <!-- Employee forms -->
        <div v-if="!employeePayrollData.length" class="cpfl-empty">
            <div class="cpfl-empty-icon"><i class="fas fa-user-slash"></i></div>
            <p class="cpfl-empty-title">No Employees Found</p>
            <p class="cpfl-empty-desc">No employees match the selected criteria.</p>
        </div>
        <div v-if="!refreshingRefs" class="cpfl-list">
            <CreatePayrollForm
                :employee="employee"
                v-for="(employee, i) of filteredEmployeePayrollData"
                :key="employee.id"
                :ref="inputRefs[i]"
            />
        </div>
    </div>
</template>

<script>
import SelectDropdown from "../crud/SelectDropdown.vue"
import CreatePayrollForm from "./CreatePayrollForm.vue"

export default {
    props: {
        employeePayrollData: { type: Array, default: () => [] },
    },
    data() {
        return {
            inputValues: [],
            inputRefs: [],
            refreshingRefs: false,
            selectedEmployeeIds: [],
        }
    },
    mounted() { this.refreshRefs() },
    components: { SelectDropdown, CreatePayrollForm },
    methods: {
        getData() {
            let finalData = []
            for (let inputRef of this.inputRefs) {
                const inputRefData = this.$refs[inputRef][0].getData()
                finalData.push(inputRefData)
            }
            return finalData
        },
        refreshRefs() {
            this.refreshingRefs = true
            this.inputRefs = this.filteredEmployeePayrollData.map((item, i) => `payroll_form_${i}`)
            setTimeout(() => { this.refreshingRefs = false })
        },
    },
    watch: {
        selectedEmployeeIds() { this.refreshRefs() },
    },
    computed: {
        filteredEmployeePayrollData() {
            return this.employeePayrollData.filter((item) => this.selectedEmployeeIds.map(String).includes(String(item.id)))
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.cpfl-selector-bar { display:flex; align-items:center; justify-content:space-between; gap:8px; background:white; border:1px solid $gray100; border-radius:8px; padding:10px 14px; margin-bottom:8px; box-shadow:$shadowSm; flex-wrap:wrap; }
.cpfl-selector-left { display:flex; align-items:center; gap:6px; }
.cpfl-selector-icon { font-size:13px; color:$primaryColor; }
.cpfl-selector-label { font-size:13px; font-weight:700; color:$gray800; }
.cpfl-selector-hint { font-size:11px; color:$gray400; font-weight:500; }
.cpfl-select-all-btn { display:inline-flex; align-items:center; gap:5px; padding:6px 12px; border:1px solid $gray200; border-radius:6px; background:white; color:$primaryColor; font-size:12px; font-weight:600; cursor:pointer; font-family:inherit; transition:all $transitionFast; i { font-size:10px; } &:hover { background:$primaryLight; border-color:rgba(0,94,137,.15); } }
.cpfl-dropdown-wrap { margin-bottom:12px; }
.cpfl-count { font-size:12.5px; color:$gray500; font-weight:500; margin-bottom:10px; }
.cpfl-count-badge { display:inline-flex; align-items:center; justify-content:center; min-width:22px; height:20px; padding:0 6px; border-radius:$radiusFull; background:$primaryColor; color:white; font-size:11px; font-weight:700; }

.cpfl-empty { text-align:center; padding:40px 20px; background:white; border:1px solid $gray100; border-radius:10px; }
.cpfl-empty-icon { width:44px; height:44px; border-radius:$radiusFull; background:$gray50; color:$gray300; display:flex; align-items:center; justify-content:center; font-size:18px; margin:0 auto 10px; }
.cpfl-empty-title { font-size:14px; font-weight:700; color:$gray700; margin:0 0 4px; }
.cpfl-empty-desc { font-size:12.5px; color:$gray400; margin:0; }

.cpfl-list { display:flex; flex-direction:column; gap:10px; }
</style>
